import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';
import ReactDOM from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * enum Tree shaking
 * https://bargsten.org/jsts/enums/
 */
var ESmallfishPerformanceGlobalKeys = {
    HtmlHead: '__sml_html_head__',
    BodyScriptsBegin: '__sml_body_scripts_begin__',
    ContentFulfilled: '__sml_content_fulfilled__',
    UserScriptsBegin: '__sml_user_scripts_begin__',
    RenderBegin: '__sml_render_begin__',
    RenderCallback: '__sml_render_callback__',
};
var ESmallfishSSRGlobalKeys = {
    RenderFlag: '__sml_ssr_render__',
    InitialProps: '__sml_ssr_initial_props__',
    StaticProps: '__sml_ssr_static_props__',
    SSGFlag: '__sml_ssg_flag__',
};
var SmallfishRenderBeginGlobalKey = ESmallfishPerformanceGlobalKeys.RenderBegin;
var SmallfishRenderCallbackGlobalKey = ESmallfishPerformanceGlobalKeys.RenderCallback;
var SmallfishSSRRenderFlagGlobalKey = ESmallfishSSRGlobalKeys.RenderFlag;
var SmallfishSSRInitialPropsGlobalKey = ESmallfishSSRGlobalKeys.InitialProps;
var SmallfishSSRStaticPropsGlobalKey = ESmallfishSSRGlobalKeys.StaticProps;
var SmallfishSSGFlagGlobalKey = ESmallfishSSRGlobalKeys.SSGFlag;

var safelyDateNow = function () { return Date && Date.now && Date.now(); };

var PAGE_PROPS_STATE_KEY = 'pageProps';
var SSR_PROPS_STATE_KEY = 'initialProps';
var SSG_PROPS_STATE_KEY = 'staticProps';

// eslint-disable-next-line @typescript-eslint/ban-types
var isFunction = function (fn) { return typeof fn === 'function'; };
var isProd = function () { return process.env.NODE_ENV === 'production'; };

function dispatchAction(prevState, action) {
    if (isFunction(action)) {
        return action(prevState);
    }
    return action;
}
function isKnownStateKey(keys, stateKey) {
    return keys.includes(stateKey);
}
function validateUnknownStateKey(keys, stateKey) {
    if (!isKnownStateKey(keys, stateKey)) {
        throw new Error("'".concat(stateKey, "' not found. It must be provided in initialState as a property key."));
    }
}
function createGlobalState(initialState) {
    var e_1, _a;
    var knownStateKeys = Object.keys(initialState);
    var dispatchers = {};
    var globalState = __assign({}, initialState);
    var initStateKey = function (stateKey) {
        dispatchers[stateKey] = new Set();
    };
    try {
        for (var knownStateKeys_1 = __values(knownStateKeys), knownStateKeys_1_1 = knownStateKeys_1.next(); !knownStateKeys_1_1.done; knownStateKeys_1_1 = knownStateKeys_1.next()) {
            var key = knownStateKeys_1_1.value;
            initStateKey(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (knownStateKeys_1_1 && !knownStateKeys_1_1.done && (_a = knownStateKeys_1.return)) _a.call(knownStateKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var addDispatcher = function (stateKey, dispatcher) {
        dispatchers[stateKey].add(dispatcher);
    };
    var removeDispatcher = function (stateKey, dispatcher) {
        dispatchers[stateKey].delete(dispatcher);
    };
    var invokeDispatchers = function (stateKey, state) {
        dispatchers[stateKey].forEach(function (listener) { return listener(state); });
    };
    /**
     * 获取 stateKey 对应的状态
     */
    var getGlobalState = function (stateKey) {
        if (!isProd()) {
            validateUnknownStateKey(knownStateKeys, stateKey);
        }
        return globalState[stateKey];
    };
    /**
     * 获取全部 globalState 对象
     */
    var getFullGlobalState = function () { return globalState; };
    /**
     * 设置全局状态（触发重新渲染）
     */
    var setGlobalState = function (stateKey, action) {
        var _a;
        if (!isProd()) {
            validateUnknownStateKey(knownStateKeys, stateKey);
        }
        globalState = __assign(__assign({}, globalState), (_a = {}, _a[stateKey] = dispatchAction(globalState[stateKey], action), _a));
        invokeDispatchers(stateKey, globalState[stateKey]);
    };
    /**
     * 使用 globalState（hook）
     */
    var useGlobalState = function (stateKey) {
        if (!isProd()) {
            validateUnknownStateKey(knownStateKeys, stateKey);
        }
        var _a = __read(useState(globalState[stateKey]), 2), partialState = _a[0], setPartialState = _a[1];
        useEffect(function () {
            addDispatcher(stateKey, setPartialState);
            // setPartialState(globalState[stateKey]);
            return function () {
                removeDispatcher(stateKey, setPartialState);
            };
        }, [stateKey]);
        var updater = useCallback(function (action) { return setGlobalState(stateKey, action); }, [stateKey]);
        return [partialState, updater];
    };
    /**
     * 额外增加的初始 state
     */
    var patchInitialState = function (stateKey, state) {
        var _a;
        if (!isKnownStateKey(knownStateKeys, stateKey)) {
            knownStateKeys.push(stateKey); // 把新的 stateKey 增加到已知 key 列表中
            initStateKey(stateKey); // 初始化 key
        }
        globalState = __assign(__assign({}, globalState), (_a = {}, _a[stateKey] = state, _a)); // 注册 state
    };
    return {
        getFullGlobalState: getFullGlobalState,
        getGlobalState: getGlobalState,
        setGlobalState: setGlobalState,
        useGlobalState: useGlobalState,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __patchInitialState__: patchInitialState,
    };
}

function installPlugins(plugins, globalState) {
    var e_1, _a;
    try {
        for (var plugins_1 = __values(plugins), plugins_1_1 = plugins_1.next(); !plugins_1_1.done; plugins_1_1 = plugins_1.next()) {
            var plugin = plugins_1_1.value;
            var api = {
                addGlobalState: function (key, initialValue) {
                    // patch initial state
                    globalState.__patchInitialState__(key, initialValue);
                    var updater = function (nextValue) {
                        globalState.setGlobalState(key, nextValue);
                    };
                    return updater;
                },
                addPageProps: function (key, initialValue) {
                    var _a;
                    var props = globalState.getGlobalState(PAGE_PROPS_STATE_KEY);
                    globalState.__patchInitialState__(PAGE_PROPS_STATE_KEY, __assign(__assign({}, props), (_a = {}, _a[key] = initialValue, _a)));
                    var updater = function (nextValue) {
                        var _a;
                        var currProps = globalState.getGlobalState(PAGE_PROPS_STATE_KEY);
                        globalState.setGlobalState(PAGE_PROPS_STATE_KEY, __assign(__assign({}, currProps), (_a = {}, _a[key] = nextValue, _a)));
                    };
                    return updater;
                },
            };
            plugin.install(api);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (plugins_1_1 && !plugins_1_1.done && (_a = plugins_1.return)) _a.call(plugins_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function reducePageComponentImplements(plugins, 
// eslint-disable-next-line @typescript-eslint/naming-convention
PageComponent) {
    return plugins.reduce(function (component, plugin) {
        return typeof plugin.createPageComponent === 'function'
            ? plugin.createPageComponent(component)
            : component;
    }, PageComponent);
}

var GlobalContext = createContext({});
var useGlobalContext = function () {
    return useContext(GlobalContext);
};
var useGlobalState = function (stateKey) {
    return useGlobalContext().globalState.useGlobalState(stateKey);
};
function bootstrap(
// eslint-disable-next-line @typescript-eslint/naming-convention
PageComponent, plugins, ssrInitialProps, staticProps) {
    var _a;
    if (plugins === void 0) { plugins = []; }
    var globalState = createGlobalState((_a = {},
        _a[PAGE_PROPS_STATE_KEY] = {},
        _a[SSR_PROPS_STATE_KEY] = ssrInitialProps || {},
        _a[SSG_PROPS_STATE_KEY] = staticProps || {},
        _a));
    installPlugins(plugins, globalState);
    PageComponent = reducePageComponentImplements(plugins, PageComponent);
    var PageContainer = function () {
        var _a = __read(globalState.useGlobalState(PAGE_PROPS_STATE_KEY), 1), pageProps = _a[0];
        var _b = __read(globalState.useGlobalState(SSR_PROPS_STATE_KEY), 1), ssrProps = _b[0];
        var _c = __read(globalState.useGlobalState(SSG_PROPS_STATE_KEY), 1), staticProps = _c[0];
        useEffect(function () {
            if (!window[SmallfishRenderCallbackGlobalKey]) {
                window[SmallfishRenderCallbackGlobalKey] = safelyDateNow();
            }
        }, []);
        return (React.createElement(GlobalContext.Provider, { value: { globalState: globalState } },
            React.createElement(PageComponent, __assign({}, pageProps, ssrProps, staticProps))));
    };
    return [PageContainer];
}

var isSSR = Boolean(window[SmallfishSSRRenderFlagGlobalKey]);
var isSSG = Boolean(window[SmallfishSSGFlagGlobalKey]);
function renderPage(mountElementId, plugins, options) {
    if (plugins === void 0) { plugins = []; }
    return __awaiter(this, void 0, void 0, function () {
        var pageExports, initialProps, staticProps, _a, PageContainer, container, root;
        return __generator(this, function (_b) {
            pageExports = options.pageExports;
            if (isSSR || isSSG) {
                initialProps = window[SmallfishSSRInitialPropsGlobalKey];
                staticProps = window[SmallfishSSRStaticPropsGlobalKey];
            }
            _a = __read(bootstrap(pageExports.default, plugins, initialProps, staticProps), 1), PageContainer = _a[0];
            window[SmallfishRenderBeginGlobalKey] = safelyDateNow();
            if (!isSSR && !isSSG) {
                if (ReactDOM.createRoot) {
                    container = document.getElementById(mountElementId);
                    root = ReactDOM.createRoot(container);
                    root.render(React.createElement(PageContainer));
                }
                else {
                    ReactDOM.render(React.createElement(PageContainer), document.getElementById(mountElementId), function () {
                        window[SmallfishRenderCallbackGlobalKey] = safelyDateNow();
                    });
                }
            }
            else {
                // SSR rehydrate，先冗余代码
                ReactDOM.hydrate(React.createElement(PageContainer), document.getElementById(mountElementId), function () {
                    window[SmallfishRenderCallbackGlobalKey] = safelyDateNow();
                });
            }
            return [2 /*return*/];
        });
    });
}

export { bootstrap, renderPage, useGlobalContext, useGlobalState };
